<template>
  <div class="productHeader">
    <h2 class="title">推荐产品</h2>
    <div class="address" @click="openModal">
      <i class="iconfont icon-dingwei-icon iconStyle dingweiColor"></i>
      <h2 class="addressText">{{ address }}</h2>
    </div>
    <div id="iCenter"></div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk';
import { getAdcodeFromProvince } from '../utils/index';
import bus from '../utils/bus';

export default {
  name: 'Address',
  data() {
    return {
      address: '全国',
      districtId: '',
      lat: '',
      lng: '',
    };
  },
  props: {
    getProductList: {
      type: Function,
      default: () => Function,
    },
  },
  mounted() {
    bus.$emit('getAddressObject', {
      address: '全国',
      districtId: '999999',
    });
    this.tokenUrl();
  },
  methods: {
    changeAddressText(text) {
      this.address = text;
      bus.$emit('getAddressObject', {
        address: text,
        districtId: this.districtId,
      });
    },
    mapGetLocation() {
      // 获取城市列表接口设置中心点
      // eslint-disable-next-line no-undef
      // const citylocation = new qq.maps.CityService({
      //   complete: (result) => {
      //     const { lat, lng } = result.detail.latLng;
      //     this.lat = lat;
      //     this.lng = lng;
      //     this.$emit('getLatLng', { lat, lng });
      //     this.tokenUrl();
      //   },
      // });
      // // 调用searchLocalCity();方法    根据用户IP查询城市信息。
      // citylocation.searchLocalCity();
      // citylocation.setError(() => {
      window.location.href = '/supermarket/v2/?address=全国&adcode=999999';
      // });
    },
    wechatAccessLocation(cb) {
      // 微信地址获取
      const Url = '/supermarket/v2/';
      const that = this;
      this.$api.LoanSupermarket.getTicketInfo(Url)
        .then(
          (res) => {
            const {
              appId, timestamp, nonceStr, signature,
            } = res.data;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId,
              timestamp,
              nonceStr,
              signature,
              jsApiList: ['getLocation'],
            });
            wx.ready(() => {
              wx.checkJsApi({
                jsApiList: ['getLocation'],
                // eslint-disable-next-line no-shadow
                success: (res) => {
                  if (res.checkResult.getLocation === false) {
                    console.log(
                      '你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！',
                    );
                  }
                },
                // eslint-disable-next-line no-shadow
                fail(res) {
                  console.info(`checkJsApi fail=${JSON.stringify(res)}`);
                },
              });
              wx.getLocation({
                type: 'wgs84',
                // eslint-disable-next-line no-shadow
                success: (res) => {
                  const { latitude } = res; // 纬度，浮点数，范围为90 ~ -90
                  const { longitude } = res; // 经度，浮点数，范围为180 ~ -180。
                  // eslint-disable-next-line no-unused-expressions
                  cb && cb(latitude, longitude);
                },
                cancel: () => {
                  that.getProductList();
                  console.log('查看附件机器，首先要授权位置信息');
                },
                // eslint-disable-next-line no-shadow
                fail: (res) => {
                  that.getProductList();
                  console.info(`ready getLocation fail=${JSON.stringify(res)}`);
                  console.log('出现故障，请联系管理员');
                },
              });
              // eslint-disable-next-line no-shadow
              wx.error((res) => {
                console.log(res);
              });
            });
          },
          (err) => {
            console.log(err);
          },
        )
        .catch(() => {});
    },
    getIsWxClient() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true;
      }
      return false;
    },
    tokenUrl() {
      const { lat, lng } = this;
      const { address, adcode } = this.$route.query;
      if (address || adcode) {
        this.address = address;
        this.districtId = adcode;
        this.getProductList(adcode);
      } else {
        this.$api.LoanSupermarket.getLocationInfo({ lat, lng }).then(
          (res) => {
            let province = res.data.province || '全国';
            if (res.data.province) {
              province = province.substr(0, province.length - 1);
            }
            const adcodess = getAdcodeFromProvince(province);
            this.address = province;
            this.districtId = adcodess;
            bus.$emit('getAddressObject', {
              address: province,
              districtId: adcodess,
            });
            this.getProductList(adcodess);
          },
          () => {},
        );
      }
    },
    getAddressObj() {
      return {
        address: this.address,
        districtId: this.districtId,
      };
    },
    openModal() {
      bus.$emit('showModal', true);
      bus.$emit('getAddressObject', {
        address: this.address,
        districtId: this.districtId,
      });
    },
  },
};
</script>
<style scoped>
.productHeader {
  height: 50px;
  padding: 0 20px;
}
.dingweiColor {
  color: #bd895a;
}
.productHeader .title {
  font-size: 17px;
  font-weight: 500;
  float: left;
}
.productHeader .address {
  height: 54px;
  float: right;
  display: flex;
}
.productHeader .address i {
  float: left;
  width: 16px;
  height: 16px;
  margin-top: 18px;
  margin-right: 5px;
}
.productHeader .address div {
  color: #bd895a;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.productHeader .address .addressText {
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #495060;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
